module.exports = __webpack_public_path__ + "img/ECatapultTrireme64_ua.d846098a.webp";